/* ============================================================
   CLAUDIO LUGLI — HOME LAB BEHAVIOURS
   Progressive enhancement only. The homepage is fully usable
   without this file. No dependencies, < 3KB.
   ------------------------------------------------------------
   1. Scroll reveal        (.cl-reveal -> .cl-inview)
   2. Toggle reveals       ([data-cl-toggle] for detail theatre
                            captions & Behind-the-Print flip)
   3. Analytics hooks      ([data-cl-event] -> dataLayer)
   4. Video pause offscreen ([data-cl-video])
   Respects prefers-reduced-motion throughout.
   ============================================================ */
(function () {
  'use strict';
  if (window.CLHome) return;
  window.CLHome = true;

  document.documentElement.classList.add('cl-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Scroll reveal ------------------------------------------------ */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cl-inview');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    document.querySelectorAll('.cl-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.cl-reveal').forEach(function (el) {
      el.classList.add('cl-inview');
    });
  }

  /* 2. Toggle reveals ------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cl-toggle]');
    if (!toggle) return;
    var target = toggle.closest(toggle.getAttribute('data-cl-toggle'));
    if (!target) return;
    var revealedClass = toggle.getAttribute('data-cl-toggle-class') || 'is-open';
    var isOpen = target.classList.toggle(revealedClass);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.is-open [data-cl-toggle], .is-revealed [data-cl-toggle]').forEach(function (toggle) {
      var target = toggle.closest(toggle.getAttribute('data-cl-toggle'));
      if (!target) return;
      var revealedClass = toggle.getAttribute('data-cl-toggle-class') || 'is-open';
      target.classList.remove(revealedClass);
      toggle.setAttribute('aria-expanded', 'false');
    });
  });

  /* 3. Analytics hooks ---------------------------------------------- */
  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-cl-event]');
    if (!el) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'cl_home_interaction',
        cl_action: el.getAttribute('data-cl-event'),
        cl_label: el.getAttribute('data-cl-label') || (el.textContent || '').trim().slice(0, 80)
      });
    } catch (e) { /* analytics must never break the page */ }
  });

  /* 4a. Adaptive hero video ------------------------------------------ */
  /* Image paints first (LCP); the right-sized MP4 rendition attaches
     only when visible, then fades in. Skipped entirely for Save-Data
     and reduced-motion visitors. */
  var adaptiveVideos = document.querySelectorAll('video[data-cl-adaptive]');
  if (adaptiveVideos.length) {
    var connection = navigator.connection || {};
    if (reduceMotion || connection.saveData) {
      adaptiveVideos.forEach(function (v) { v.remove(); });
    } else if ('IntersectionObserver' in window) {
      var adaptiveObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (!entry.isIntersecting) {
              if (v.src) v.pause();
              return;
            }
            if (!v.src) {
              try {
                var sources = JSON.parse(v.getAttribute('data-cl-sources')) || [];
                sources.sort(function (a, b) { return a.width - b.width; });
                var need = v.clientWidth || window.innerWidth;
                var pick = null;
                for (var i = 0; i < sources.length; i++) {
                  if (sources[i].width >= need) { pick = sources[i]; break; }
                }
                if (!pick) pick = sources[sources.length - 1];
                if (pick) {
                  v.addEventListener('canplay', function () { v.classList.add('is-ready'); }, { once: true });
                  v.src = pick.url;
                }
              } catch (e) { /* fall back to the still image */ }
            }
            var playPromise = v.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          });
        },
        { threshold: 0.1 }
      );
      adaptiveVideos.forEach(function (v) { adaptiveObserver.observe(v); });
    }
  }

  /* 4b. Pause offscreen / reduced-motion video (legacy embeds) -------- */
  var videos = document.querySelectorAll('video[data-cl-video]');
  if (videos.length) {
    if (reduceMotion) {
      videos.forEach(function (v) {
        v.removeAttribute('autoplay');
        v.pause();
        v.controls = false;
      });
    } else if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        },
        { threshold: 0.15 }
      );
      videos.forEach(function (v) { videoObserver.observe(v); });
    }
  }
})();
